export enum PpReportSubject {
  Employee,
  Supervisor,
  Program
}
